var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.492 8.02041C15.5567 7.4898 15.4274 6.93878 15.1257 6.4898C15.1257 6.46939 15.1257 6.42857 15.1257 6.40816C15.1257 6.18367 15.0611 5.97959 14.9749 5.79592C14.8241 2.57143 12.6048 0 9.00652 0C5.40825 0 3.18896 2.57143 3.03814 5.81633C2.95195 6 2.88731 6.20408 2.88731 6.42857V6.5102C2.58566 6.95918 2.45638 7.4898 2.52102 8.02041C1.93927 8.22449 1.18514 9.14286 0.624929 10.3878C-0.0861053 11.9592 -0.215384 13.4898 0.366371 13.7551C0.754208 13.9592 1.37906 13.5102 1.96081 12.6939C2.19782 13.5714 2.75803 14.3878 3.55525 15.0204C2.71494 15.3265 2.15473 15.8163 2.15473 16.3673C2.15473 17.2653 3.66299 18 5.49444 18C7.15352 18 8.53249 17.4082 8.79105 16.6327H9.17889C9.45899 17.4082 10.838 18 12.4971 18C14.35 18 15.8368 17.2653 15.8368 16.3673C15.8368 15.8163 15.2765 15.3265 14.4362 15.0408C15.2335 14.3878 15.8152 13.5918 16.0307 12.7143C16.6124 13.5102 17.2373 13.9592 17.6251 13.7551C18.2069 13.4898 18.0991 11.9592 17.3881 10.3878C16.8279 9.14286 16.0522 8.22449 15.492 8.02041Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQq);
export default __webpack_public_path__ + "static/media/QQ.166c38212eca887a2a56690e845b4cd6.svg";
export { ForwardRef as ReactComponent };